import { useState } from "react";
import { downloadBlob, notifyError } from "@marekl/adminer/api";
import { apiClient } from "./api";
import { runtimeConfig } from "./config";
import { documentHtmlUrl } from "./queries/documents";

/**
 * Opens the document's render and the browser's print dialog for it.
 *
 * Browsers leave backgrounds out of a print by default, and the render's
 * shaded boxes (the customer, the dates, the totals) would vanish. The
 * template's CSS stays byte-identical to the legacy one (AGENTS.md
 * "Rendering"), so the opt-in is added to the opened window instead.
 */
export function printDocument(companyId: string, id: string) {
  const w = window.open(documentHtmlUrl(runtimeConfig.apiBaseURL, companyId, id), "_blank");
  w?.addEventListener("load", () => {
    const style = w.document.createElement("style");
    style.textContent = "* { -webkit-print-color-adjust: exact; print-color-adjust: exact; }";
    w.document.head.append(style);
    w.print();
  });
}

/**
 * The PDF download (via PDFy). A failure — PDFy not configured or down — is
 * a toast, wherever the download was started from (the list's "akce" menu,
 * the detail's PDF button).
 */
export function useDocumentPdf(companyId: string) {
  const [pending, setPending] = useState(false);
  return {
    pending,
    download: async (id: string) => {
      setPending(true);
      try {
        await downloadBlob(apiClient, `/companies/${companyId}/documents/${id}/pdf`);
      } catch (err) {
        notifyError(err);
      } finally {
        setPending(false);
      }
    },
  };
}
